import React from 'react';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';

interface ResizeHandleProps {
  resizeHandler: (event: React.MouseEvent<HTMLDivElement>) => void;
  resetSize: () => void;
  isResizing: boolean;
  dragLineHeight: number;
}

export const ResizeHandle = ({ resizeHandler, resetSize, isResizing, dragLineHeight }: ResizeHandleProps) => (
  <Box
    onMouseDown={e => resizeHandler(e)}
    onDoubleClick={() => resetSize()}
    className="drag-handle"
    sx={[
      {
        ...flex.justifyEndCenter,
        cursor: 'col-resize',
        position: 'absolute',
        right: 0,
        width: '10px',
      },
      isResizing
        ? { top: 0, height: dragLineHeight, opacity: 1 }
        : {
            top: '50%',
            height: '60%',
            transform: 'translateY(-50%)',
            opacity: 0,
          },
    ]}>
    <Box
      sx={{
        width: '2px',
        height: '100%',
        background: isResizing ? 'var(--color-border-interactive-primary-default)' : 'var(--color-border-base-secondary)',
      }}
    />
  </Box>
);
